module.exports = __webpack_public_path__ + "static/img/group-13@3x.c93e7928.png";